// 👥 Employés E4b — dialogue de l'app pour la garde « modifications non enregistrées » (remplace window.confirm).
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

export function DialogueModifsNonEnregistrees({ open, onContinuer, onAbandonner }) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onContinuer(); }}>
      <DialogContent className="max-w-md" data-testid="dialogue-modifs-non-enregistrees">
        <DialogHeader>
          <DialogTitle>Modifications non enregistrées</DialogTitle>
          <DialogDescription>Des modifications de cette section ne sont pas enregistrées. Voulez-vous continuer à les modifier ou les abandonner ?</DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onContinuer} data-testid="dialogue-modifs-continuer">Continuer la modification</Button>
          <Button variant="destructive" onClick={onAbandonner} data-testid="dialogue-modifs-abandonner">Abandonner les modifications</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
